var exports = {
  "kL": "xe564cbfb--e5d0f7--container",
  "S$": "xe564cbfb--e5d0f7--container--with-image",
  "vW": "xe564cbfb--e5d0f7--inner",
  "RJ": "xe564cbfb--e5d0f7--description-wrapper",
};

module.exports = exports;
